import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=5f23044a&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f23044a')) {
      api.createRecord('5f23044a', component.options)
    } else {
      api.reload('5f23044a', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=5f23044a&", function () {
      api.rerender('5f23044a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/Account.vue"
export default component.exports